import React from 'react';
import { IGenericFiltersData, IGridFetchData } from '@components-library/Grid/GridContext';
import { IGridExportDropdownProps } from '@components-library/Grid/GridExportDropdown/GridExportDropdown';
import { GridContextPersistenceName } from '@components-library/Grid/gridContextPersistence.service';
import { ColumnDef, InitialTableState } from '@tanstack/react-table';

export const ACTION_COLUMN_ID = 'actions';

export interface IGridFilters<T extends IGenericFiltersData, P = never> {
  onFilter?: IGridFetchData<T>;
  exportEvent?: string;
  processing?: boolean;
  exportSettings?: IGridExportDropdownProps<T>;
  parentContext?: P;
}

export interface IGridActionType {
  [ACTION_COLUMN_ID]?: never;
}

interface TableClassNames {
  tableWrapper?: string;
  table?: string;
  cell?: string;
  row?: string;
  headerCell?: string;
}

export type IGridColumns<T> = ColumnDef<T & IGridActionType, any>[];

export interface IGridProps<T extends Record<string, unknown>, K extends Record<string, unknown>> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: IGridColumns<T>;
  data: T[];
  isCountNotAccurate?: boolean;
  classes?: TableClassNames;
  initialState?: Omit<InitialTableState, 'columnOrder' | 'sorting'>;
  totalCount?: number;
  rowSelectionEnabled?: boolean;
  columnResizeEnabled?: boolean;
  headerSection?: React.ReactNode;
  /** Required field for persisting data in localStorage */
  gridName?: GridContextPersistenceName;
  showColumnsConfigurator?: boolean;
  viewMode?: 'primary' | 'secondary';
  tableLayout?: 'auto' | 'fixed';
  processing?: boolean;
  noDataPlaceholderText?: string;
  onPaginationChange?: IGridFetchData<K>;
  getRowId?: (originalRow: T, index: number, parent: unknown) => string;
}
